module.exports = __webpack_public_path__ + "static/media/4.20dad43d.svg";